import React from 'react'
import {useLayout} from '../../core'
import {Toolbar1} from './Toolbar1'

const Toolbar = () => {
  const {config} = useLayout()

  switch (config.toolbar.layout) {
    case 'toolbar1':
      return <Toolbar1 />
    case 'none':
      return <></>
    default:
      return <Toolbar1 />
  }
}

export {Toolbar}
